import React from 'react';
import { Radio } from 'antd';
import { twisterType as type } from 'app/constants/twisterType.constants';
import withTranslations from 'app/components/HOGs/withTranslations';
import {
  FingerDrawIcon,
  ToPointIcon,
  RoundTripIcon,
  RidePlanIcon,
} from '../../icons.svg';

const RideTwisterSwitcher = (props) => {
  const { scope, setScope, tr } = props;
  return (
    <>
      <div className="rtTitle">{tr['Tourstart RideTwister']}</div>
      <Radio.Group
        value={scope}
        onChange={(val) => setScope(val.target.value)}
        buttonStyle="solid"
      >
        <Radio.Button value={type.FreeHand}>
          <div className="rtSwitcherItem">
            <FingerDrawIcon />
            <span>{tr['Finger Draw']}</span>
          </div>
        </Radio.Button>
        <Radio.Button value={type.ToPoint}>
          <div className="rtSwitcherItem">
            <ToPointIcon />
            <span>{tr.Destination}</span>
          </div>
        </Radio.Button>
        <Radio.Button value={type.RoundTrip}>
          <div className="rtSwitcherItem">
            <RoundTripIcon />
            <span>{tr['Round Trip']}</span>
          </div>
        </Radio.Button>
        <Radio.Button value={type.RidePlan}>
          <div className="rtSwitcherItem">
            <RidePlanIcon />
            <span>{tr.Poi}</span>
          </div>
        </Radio.Button>
      </Radio.Group>
    </>
  );
};

export default withTranslations(RideTwisterSwitcher);
